import Reactive from '../general/reactive';

const EVENTS = {
  Notify: 'notify',
  ResetVideoSource: 'resetVideoSource',
  ErrorGettingStream: 'errorGettingStream',
};

class Stream extends Reactive {
  constructor(params) {
    super(params);
    this.prop('ro', 'label', params.label);
    this.prop('ro', 'kind', params.kind);
    this.prop('rw', 'constraints', params.constraints);
    this.prop('rw', 'videoResolutionTry', 0);
    this.prop('rw', 'mediaStream', null);
    this.prop('rw', 'senders', {});
    this.prop('rw', 'enabled', (typeof params.enabled === 'undefined' ? true : params.enabled));
    this.prop('rw', 'constraintsChanged', true);
    this.videoResolutionTryOrder = ['1080p', '1080p', '1080p', '720p'];
    if (window.product === 'presenter') {
      this.videoResolutionTryOrder = ['360p', '360p', '360p', '240p', '144p'];
    }

    if (this.enabled) this.unmute(); else this.mute();
    this.on('update[enabled]', (newValue) => {
      if (newValue) this.unmute();
      else this.mute();
    });
  }

  static compare(obj1, obj2) {
    return JSON.stringify(obj1) === JSON.stringify(obj2);
  }

  setConstraints(constraints) {
    const constraintsChanged = !Stream.compare(constraints, this.constraints) || this.videoResolutionTry != 0;
    this.update({ constraints, constraintsChanged });
  }

  async refresh() {
    if (this.constraintsChanged === false) {
      // console.log("CONSTRAINTS NOT CHANGED", this.label);
      return;
    }
    if (this.constraints === false) {
      this.stop();
      this.update({ mediaStream: null });
      return;
    }
    if (this.mediaStream != null) {
      this.stop();
    }
    const stream = await this.getStream(this.constraints)
      .catch((e) => { this.handleStreamError(e); });
    this.update({ mediaStream: stream });

    if (stream) {
      // console.log('GOT STREAM FOR', this.label);
      // restore the state of the stream
      if (this.enabled) this.unmute(); else this.mute();
      this.toggle(this.enabled);
      // emit to listeners
      this.emit('GOT_STREAM', this.label, stream);
      stream.onremovetrack = (e) => { alert(e); };
      this.update({ constraintsChanged: false });

      // stream.getAudioTracks().forEach(track => {
      //   let settings = track.getSettings();
      // })


    }
  }

  // Returns the MediaStreamId and label separated by "__", this is for identifying purposes when using an SFU
  // and multiple streams of the same kind
  getLabelDict() {
    // if the stream is not yet set then dont do anything
    if (this.mediaStream == null) return;
    return `${this.mediaStream.id}__${this.label}`;
  }

  setMediaStream(mediaStream) {
    this.update({ mediaStream });
  }

  async getStream(constraints) {
    let stream;
    if (constraints.video && (constraints.mediaSource === 'screen' || constraints.video.mediaSource === 'screen')) {
      // TODO: Add audio with constraint: audio: true
      stream = await navigator.mediaDevices.getDisplayMedia({ video: true });
    } else {
      // console.log("Getting stream with constraints: ", constraints)
      stream = await navigator.mediaDevices.getUserMedia(constraints)
        .catch((err) => { throw err; });
      // stream.getTracks().forEach((t) => {
      //   console.log(t.getSettings())
      // })
      // console.log("Got streams with constraints", )
    }
    return stream;
  }

  handleStreamError(error) {
    console.error('ERROR', error);
    if (error.name === 'OverconstrainedError' && error.constraint !== 'deviceId') {
      // set videoresolution just in case
      // $(`#videoResolution option[value=${videoResolution}]`).attr('selected', 'selected');
      let videoResolutionTry = this.videoResolutionTry + 1;
      if (videoResolutionTry >= this.videoResolutionTryOrder.length) videoResolutionTry = 0;
      this.update({ videoResolutionTry });
      const videoResolution = this.videoResolutionTryOrder[this.videoResolutionTry];
      console.info('Error getting video, setting new resolution to', this.videoResolutionTry, videoResolution);
      this.emit('updateVideoResolution', videoResolution);
      if (error.constraint == "width"){
        this.emit(EVENTS.Notify, `The selected device didn't support the resolution selected, trying with: ${videoResolution}`, 'error');
      } else{
        this.emit(EVENTS.Notify, `There was an error getting the stream: ${error.message}${error.constraint}`, 'error');
      }
    } else {
      // the device is probably busy, just
      if (error.name === 'OverconstrainedError' && error.constraint === 'deviceId') {
        window.setTimeout(() => {
          this.emit(EVENTS.ErrorGettingStream);
          this.emit(EVENTS.ResetVideoSource);
          this.emit(EVENTS.Notify, 'The selected camera is busy, defaulting to none');
        }, 1000);
      } else {
        window.setTimeout(() => {
          this.emit('updateVideoResolution', '720p');
          console.error('ERROR', error);
        }, 3000);
        // try updating the quality to 720p. Some laptops dont have 1080p cameras
        this.emit(EVENTS.Notify, `There was an error getting the stream: ${error.message}${error.constraint}`, 'error');
      }
    }
  }

  stop() {
    if (this.mediaStream != null && this.mediaStream.getTracks) {
      this.mediaStream.getTracks().forEach((track) => {
        track.stop();
      });
    }
  }

  toggle(enabled) {
    if (this.mediaStream == null || !this.mediaStream.getTracks) {
      // console.log('%s STREAM DOESNT EXIST', this.label);
      return;
    }
    this.mediaStream.getTracks().forEach((track) => {
      if (track.kind.toUpperCase() === this.kind) track.enabled = enabled;
    });
    // this.update({ enabled });
  }

  mute() {
    this.toggle(false);
    this.emit('MUTED');
  }

  unmute() {
    this.toggle(true);
    this.emit('UNMUTED');
  }

  static getStats() {}

  // when the constraints are updated notify all the subscriber
}
export default Stream;
